export const workflowCreateActionTextParser = action => {
  return action.query;
};